import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { ContactsApi } from "@socotec.io/atm-back-sdk";

const api = new ContactsApi(atmBackConfiguration);

/**
 * @param {object} contactData must carry `uuid`; remaining keys are merge-patched
 * @returns {Promise<object>} the updated contact
 */
export const updateContact = async (contactData) => {
  const { uuid, ...rest } = contactData;
  return await api.partialUpdate({ uuid, patchedContactRequest: rest });
};
